import React from 'react'
import Label from "components/general/Label"
import { findArray } from 'helpers/utils'
import ResultRank from "components/presentation/ResultRank"
import { ColumnBib, ColumnName, ColumnNoc, ColumnMove, ColumnExpander } from "components/common/TableColumns"
import { ColumnIntermediateRank } from "components/common/TableColumnsIntermediates"


export function TableColumns(columnsAdded) {
    let numCols = findArray(columnsAdded, { ei_code: ['INTERMEDIATES'] })?.ei_value
        ? findArray(columnsAdded, { ei_code: ['INTERMEDIATES'] })?.ei_value
        : findArray(columnsAdded, { ei_code: ['INTERMEDIATES_TOTAL'] })?.ei_value;
    //Create Columns splits
    let columnsExt = columnsAdded.filter(row => row.ei_code === 'INTERMEDIATE').map((val) => {
        const filters = {
            er_code: ['INTERMEDIATE'],
            er_pos: [val.ei_pos]
        };

        let _header = <>{val.ei_value}&nbsp;<Label data="LabelMeters" /></>
        _header = Number(val.ei_pos) === Number(numCols) ? val.ei_value : _header

        return (
            {
                Header: _header,
                accessor: (props) => {
                    let extendedResult = findArray(props?.resultAnalysis?.extendedResults, filters);
                    return (
                        extendedResult ? Number(extendedResult.er_sortorder) : null
                    )
                },
                sortType: "absoluteOrderNumber",
                disableSortBy: false,
                isVisible: false,
                columnIndex: val.ei_pos,
                id: 'ResultEx' + val.ei_pos,
                className: 'text-end',
                headerClassName: 'text-end w-10',
                Cell: (props) => {
                    let extendedResult = findArray(props.cell.row.original?.resultAnalysis?.extendedResults, filters);
                    if (extendedResult) {
                        return (
                            extendedResult.er_value
                        )
                    }
                }

            }
        )
    })

    return (
        [
            ColumnIntermediateRank({ type: 'resultAnalysis' }),
            ColumnMove({ headerClassName: 'w-5' }),
            ColumnNoc({}),
            ColumnName({}), //ColumnName({ label: 'HeaderBib' }),
            ...columnsExt,
            ColumnExpander({ type: 'resultAnalysis' })
        ]
    )
}

export default TableColumns
